import { createContext, useContext } from 'react';

const InterviewStageManager = createContext({
  interviewPlan: null,
  activityDisclosure: { isOpen: false, onOpen: () => {}, onClose: () => {} },
  setInterviewPlan: () => {},
  selectedActivity: 'select_activity',
  setSelectedActivity: () => {},
  activityAction: {},
  setActivityAction: () => {},
  isSettings: false,
  disableActivity: false,
  jobId: null,
  refresh: () => {},
  canEditJob: false,
  scorecardParams: {},
});

InterviewStageManager.displayName = 'InterviewStageManager';

export const useInterviewStageManager = () => {
  const InterviewStageManagerContext = useContext(InterviewStageManager);
  return InterviewStageManagerContext;
};

export const InterviewStageProvider = InterviewStageManager.Provider;
